module.exports = __webpack_public_path__ + "img/icon_student_online_registry.41079800.svg";